import { Routes } from '@angular/router';
import { MainLayoutComponent } from './shared/layouts/main-layout/main-layout.component';
import { sessaoGuard, sessaoChildGuard } from './core/auth/guards/sessao.guard';
import { loginGuard } from './core/auth/guards/login.guard';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [loginGuard],
    loadChildren: () => import('./features/acesso/acesso.routes').then(m => m.ACESSO_ROUTES)
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [sessaoGuard],
    canActivateChild: [sessaoChildGuard],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      {
        path: 'home',
        loadChildren: () => import('./features/home/home.routes').then(m => m.HOME_ROUTES)
      },
      {
        path: 'minha-conta',
        loadChildren: () => import('./features/minha-conta/minha-conta.routes').then(m => m.MINHA_CONTA_ROUTES)
      },
      {
        path: 'dashboards',
        loadChildren: () => import('./features/dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES)
      },
      {
        path: 'auditoria',
        loadChildren: () => import('./features/auditoria/auditoria.routes').then(m => m.AUDITORIA_ROUTES)
      },
      {
        path: 'empresas',
        loadChildren: () => import('./features/empresas/empresas.routes').then(m => m.EMPRESAS_ROUTES)
      },
      {
        path: 'fornecedores-ap-sp',
        loadChildren: () => import('./features/fornecedores-ap-sp/fornecedores-ap-sp.routes').then(m => m.FORNECEDORES_AP_SP_ROUTES)
      },
      {
        path: 'relatorios-empresa',
        loadChildren: () => import('./features/relatorios-empresa/relatorios-empresa.routes').then(m => m.RELATORIOS_EMPRESA_ROUTES)
      },
      {
        path: 'categorias',
        loadChildren: () => import('./features/categorias/categorias.routes').then(m => m.CATEGORIAS_ROUTES)
      },
      {
        path: 'titulos',
        loadChildren: () => import('./features/titulos/titulos.routes').then(m => m.TITULOS_ROUTES)
      },
      {
        path: 'pecas',
        loadChildren: () => import('./features/pecas/pecas.routes').then(m => m.PECAS_ROUTES)
      },
      {
        path: 'relatorios-pc',
        loadChildren: () => import('./features/relatorios-pc/relatorios-pc.routes').then(m => m.RELATORIOS_PC_ROUTES)
      },
      {
        path: 'relatorios-ap',
        loadChildren: () => import('./features/relatorios-ap/relatorios-ap.routes').then(m => m.RELATORIOS_AP_ROUTES)
      },
      {
        path: 'relatorios-ois',
        loadChildren: () => import('./features/relatorios-ois/relatorios-ois.routes').then(m => m.RELATORIOS_OIS_ROUTES)
      },
      {
        path: 'relatorios-ois-ativas',
        loadChildren: () => import('./features/relatorios-ois-ativas/relatorios-ois-ativas.routes').then(m => m.RELATORIOS_OIS_ATIVAS_ROUTES)
      },
      {
        path: 'relatorios-financeiros',
        loadChildren: () => import('./features/relatorios-financeiros/relatorios-financeiros.routes').then(m => m.RELATORIOS_FINANCEIROS_ROUTES)
      },
      {
        path: 'prestacoes-contas',
        loadChildren: () => import('./features/prestacoes-contas/prestacoes-contas.routes').then(m => m.PRESTACOES_CONTAS_ROUTES)
      },
      {
        path: 'produtos',
        loadChildren: () => import('./features/produtos/produtos.routes').then(m => m.PRODUTOS_ROUTES)
      },
      {
        path: 'usuarios',
        loadChildren: () => import('./features/usuarios/usuarios.routes').then(m => m.USUARIOS_ROUTES)
      },
      {
        path: 'funcionarios',
        loadChildren: () => import('./features/funcionarios/funcionarios.routes').then(m => m.FUNCIONARIOS_ROUTES)
      },
      {
        path: 'relatorios-funcionario',
        loadChildren: () => import('./features/relatorios-funcionario/relatorios-funcionario.routes').then(m => m.RELATORIOS_FUNCIONARIO_ROUTES)
      },
      {
        path: 'unidades',
        loadChildren: () => import('./features/unidades/unidades.routes').then(m => m.UNIDADES_ROUTES)
      },
      {
        path: 'contas-despesa',
        loadChildren: () => import('./features/contas-despesa/contas-despesa.routes').then(m => m.CONTAS_DESPESA_ROUTES)
      },
      {
        path: 'cidades',
        loadChildren: () => import('./features/cidades/cidades.routes').then(m => m.CIDADES_ROUTES)
      },
      {
        path: 'grupos-empresariais',
        loadChildren: () => import('./features/grupos-empresariais/grupos-empresariais.routes').then(m => m.GRUPOS_EMPRESARIAIS_ROUTES)
      },
      {
        path: 'gerentes',
        loadChildren: () => import('./features/gerentes/gerentes.routes').then(m => m.GERENTES_ROUTES)
      },
      {
        path: 'vinculos-empresas',
        loadChildren: () => import('./features/vinculos-empresas/vinculos-empresas.routes').then(m => m.VINCULOS_EMPRESAS_ROUTES)
      },
      {
        path: 'veiculos',
        loadChildren: () => import('./features/veiculos/veiculos.routes').then(m => m.VEICULOS_ROUTES)
      },
      {
        path: 'campanhas',
        loadChildren: () => import('./features/campanhas/campanhas.routes').then(m => m.CAMPANHAS_ROUTES)
      },
      {
        path: 'rcs',
        loadChildren: () => import('./features/rcs/rcs.routes').then(m => m.RCS_ROUTES)
      },
      {
        path: 'ois',
        loadChildren: () => import('./features/ois/ois.routes').then(m => m.OIS_ROUTES)
      },
      {
        path: 'autorizacoes',
        loadChildren: () => import('./features/autorizacoes/autorizacoes.routes').then(m => m.AUTORIZACOES_ROUTES)
      },
      {
        path: 'pedidos-insercao',
        loadChildren: () => import('./features/pedidos-insercao/pedidos-insercao.routes').then(m => m.PEDIDOS_INSERCAO_ROUTES)
      },
      {
        path: 'veiculacoes',
        loadChildren: () => import('./features/veiculacoes/veiculacoes.routes').then(m => m.VEICULACOES_ROUTES)
      },
      {
        path: 'importacao-ap-pi',
        loadChildren: () => import('./features/importacao-ap-pi/importacao-ap-pi.routes').then(m => m.IMPORTACAO_AP_PI_ROUTES)
      },
      {
        path: 'pre-ois',
        loadChildren: () => import('./features/pre-ois/pre-ois.routes').then(m => m.PRE_OIS_ROUTES)
      },
      {
        path: 'sp-agencia',
        loadChildren: () => import('./features/sp-agencia/sp-agencia.routes').then(m => m.SP_AGENCIA_ROUTES)
      },
      {
        path: 'sps',
        loadChildren: () => import('./features/sps/sps.routes').then(m => m.SPS_ROUTES)
      },
      {
        path: 'sacs',
        loadChildren: () => import('./features/sacs/sacs.routes').then(m => m.SACS_ROUTES)
      },
      {
        path: 'relatorios-sac',
        loadChildren: () => import('./features/relatorios-sac/relatorios-sac.routes').then(m => m.RELATORIOS_SAC_ROUTES)
      },
      {
        path: 'relatorios-sp',
        loadChildren: () => import('./features/relatorios-sp/relatorios-sp.routes').then(m => m.RELATORIOS_SP_ROUTES)
      }
    ]
  },
  { path: '**', redirectTo: 'home' }
];
